export class SignoutState {
    private _isSigningOut = false;

    constructor() {}

    get isSigningOut() {
        return this._isSigningOut;
    }

    set isSigningOut(_isSigningOut: boolean) {
        this._isSigningOut = _isSigningOut;
    }
}
